import type { FC } from "react";

import { PointsAmountBanner as UIPointsAmountBanner } from "@jti/loyalty/components/PointsAmountBanner";

import type { pointsAmountBannerInputs } from "./PointsAmountBanner.builder";

type PointsAmountBannerBuilderProps = BuilderComponentProps<typeof pointsAmountBannerInputs>;

export const PointsAmountBanner: FC<PointsAmountBannerBuilderProps> = (props) => {
  return <UIPointsAmountBanner {...props} isMarginRemoved />;
};
